/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import {
  InputAttributes,
  PatternFormat,
  PatternFormatProps,
} from 'react-number-format';

import { Input } from '@ast/magma/components/input';

export type CentsFieldProps = Omit<
PatternFormatProps<InputAttributes & {
  readonly label?: string
}>,
'format'
>;

export type CentsFieldRef = HTMLInputElement;

export const CentsField = React.forwardRef(
  (
    props: CentsFieldProps,
    ref: React.Ref<CentsFieldRef>,
  ) => {
    const {
      onChange,
      onValueChange,
      ...restProps
    } = props;

    return (
      <PatternFormat
        {...restProps}
        // workaround because of not compatible interfaces. Need fix in Magma
        customInput={Input as React.ComponentType<InputAttributes>}
        // eslint-disable-next-line i18next/no-literal-string
        format="##¢"
        getInputRef={ref}
        inputMode="numeric"
        onValueChange={(values, sourceInfo) => {
          const { value } = values;
          const event = sourceInfo.event as React.ChangeEvent<HTMLInputElement>;
          if (onValueChange) onValueChange(values, sourceInfo);
          if (event && onChange) {
            event.target.value = value;
            onChange(event);
          }
        }}
      />
    );
  },
);
